/**
 * Il pass di PingUp: un amministratore di sistema lavora nell'organizzazione
 * di un cliente senza iscriversi. Vive solo in questo browser: l'API riconosce
 * l'organizzazione dall'intestazione X-Tenant-Id (activeTenantId), che agli
 * amministratori di sistema apre qualsiasi organizzazione con tutti i
 * permessi, e annota nel registro le modifiche (services/registroPingup.js).
 * Nella pagina Persone del cliente non compare nessuno.
 *
 * { tenant, cliente: { id, nome, email }, da, tenantPrima }
 * tenant ha la forma di quelli di /auth/me (tenant_id, _id, name, is_master,
 * parent_tenant_id, owner_user_id, role); tenantPrima e' l'organizzazione
 * attiva prima di entrare, per tornarci all'uscita.
 */
const CHIAVE = "pingupPass";

export function leggiPass() {
  try {
    const pass = JSON.parse(localStorage.getItem(CHIAVE) || "null");
    return pass?.tenant?.tenant_id ? pass : null;
  } catch {
    return null;
  }
}

/** L'organizzazione di un cliente (dalla pagina Clienti) nella forma del pass. */
export function tenantDelPass(org, cliente) {
  const principale = (cliente.ownedTenants || []).find((o) => o.is_master);
  const id = String(org.id);
  return {
    tenant_id: id,
    _id: id,
    name: org.name,
    is_master: org.is_master !== false,
    parent_tenant_id: org.is_master === false && principale ? String(principale.id) : null,
    owner_user_id: String(cliente.id),
    role: "admin",
  };
}

/** Entra nell'organizzazione e apre la sua dashboard. */
export function apriPass(org, cliente) {
  const pass = {
    tenant: tenantDelPass(org, cliente),
    cliente: { id: String(cliente.id), nome: cliente.name || null, email: cliente.email || null },
    da: new Date().toISOString(),
    tenantPrima: localStorage.getItem("activeTenantId"),
  };
  localStorage.setItem(CHIAVE, JSON.stringify(pass));
  localStorage.setItem("activeTenantId", pass.tenant.tenant_id);
  window.location.href = "/home";
}

/** Toglie il pass e rimette l'organizzazione di prima, senza cambiare pagina. */
export function togliPass() {
  const pass = leggiPass();
  localStorage.removeItem(CHIAVE);
  if (!pass) return;
  if (pass.tenantPrima && pass.tenantPrima !== pass.tenant.tenant_id) {
    localStorage.setItem("activeTenantId", pass.tenantPrima);
  } else {
    localStorage.removeItem("activeTenantId");
  }
}

/** Esce dall'organizzazione del cliente e torna alla pagina Clienti. */
export function esciDalPass() {
  togliPass();
  window.location.href = "/admin";
}
